import React from 'react';
import styled from 'styled-components';

const TextTable: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default TextTable;

const Container = styled.div`
  color: #666;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;

  .hidden{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;

    cursor: pointer;
  }
`;
